// This is an auto-generated file. Please do not edit directly.
// For instructions on editing source .json files, please see:
// https://git.hubteam.com/HubSpot/UIComponents/tree/master/HubStyleTokens
// ***********************************************************************
'use es6';

export var BASE_FONT_COLOR = '#33475b';
export var BASE_LINK_COLOR = '#0091ae';
export var BASE_LINK_ACTIVE_COLOR = '#7fd1de';
export var BASE_LINK_HOVER_COLOR = '#007a8c';
export var BASE_SELECTION_BACKGROUND_COLOR = '#eaf0f6';
export var BASE_BACKGROUND_COLOR = '#ffffff';
export var BASE_BACKGROUND_COLOR_MEDIUM = '#f5f8fa';
export var BASE_BACKGROUND_COLOR_DARK = '#33475b';
export var BASE_FONT_CONTRAST_COLOR = '#ffffff';
export var BASE_SHADOW_COLOR = '#000000';
export var BUTTON_DISABLED_BACKGROUND_COLOR = '#eaf0f6';
export var CARD_SHADOW_COLOR = '#2d3e50';
export var FLOATING_BUTTON_GROUP_ITEM_BACKGROUND_COLOR = '#425b76';
export var FLOATING_BUTTON_GROUP_ITEM_BORDER_COLOR = '#516f90';
export var FLOATING_BUTTON_GROUP_ITEM_COLOR = '#ffffff';
export var FLOATING_BUTTON_GROUP_ITEM_HOVER_BACKGROUND_COLOR = '#516f90';
export var FLOATING_BUTTON_GROUP_ITEM_SELECTED_BACKGROUND_COLOR = '#33475b';
export var CODE_BACKGROUND_COLOR = '#eaf0f6';
export var CODE_FOREGROUND_COLOR = '#33475b';
export var CODE_BLOCK_BACKGROUND_COLOR = '#f5f8fa';
export var CONNECTED_STEP_SELECTED_COLOR = '#ff7a59';
export var CONNECTED_STEP_UNSELECTED_COLOR = '#cbd6e2';
export var DARK_LINK_COLOR = '#ffffff';
export var DARK_LINK_ACTIVE_COLOR = '#eaf0f6';
export var DARK_LINK_HOVER_COLOR = '#7fd1de';
export var DARK_LINK_ICON_COLOR = '#ffffff';
export var BRIGHT_LINK_COLOR = '#33475b';
export var BRIGHT_LINK_ACTIVE_COLOR = '#33475b';
export var BRIGHT_LINK_HOVER_COLOR = '#33475b';
export var BRIGHT_LINK_ICON_COLOR = '#425b76';
export var DANGER_LINK_COLOR = '#f2545b';
export var DANGER_LINK_ACTIVE_COLOR = '#d94c53';
export var DANGER_LINK_HOVER_COLOR = '#d94c53';
export var MENTION_LINK_COLOR = '#425b76';
export var MENTION_LINK_ACTIVE_COLOR = '#33475b';
export var MENTION_LINK_HOVER_COLOR = '#33475b';
export var DROPDOWN_BACKGROUND_COLOR = '#ffffff';
export var DROPDOWN_BORDER_COLOR = '#cbd6e2';
export var DROPDOWN_SELECTED_BACKGROUND_COLOR = '#e5f5f8';
export var DROPDOWN_SEARCH_BACKGROUND_COLOR = '#ffffff';
export var DROPDOWN_SEARCH_WRAPPER_BACKGROUND_COLOR = '#eaf0f6';
export var DROPDOWN_CARET_COLOR = '#00a4bd';
export var TOOLBAR_DARK_BACKGROUND_COLOR = '#253342';
export var TOOLBAR_DARK_FOREGROUND_COLOR = '#ffffff';
export var EDITOR_LAYOUT_SHADOW_COLOR = '#516f90';
export var FORM_CONTROL_BACKGROUND_COLOR = '#f5f8fa';
export var FORM_CONTROL_FOREGROUND_COLOR = '#33475b';
export var FORM_CONTROL_BORDER_COLOR = '#cbd6e2';
export var FORM_CONTROL_READONLY_BACKGROUND_COLOR = '#eaf0f6';
export var FORM_CONTROL_READONLY_BORDER_COLOR = '#eaf0f6';
export var FORM_COPYABLE_BACKGROUND_COLOR = '#ffffff';
export var FORM_DISABLED_COLOR = '#cbd6e2';
export var FORM_DISABLED_BACKGROUND_COLOR = '#eaf0f6';
export var FORM_PLACEHOLDER_COLOR = '#7c98b6';
export var FORM_STATIC_LABELS_BACKGROUND_COLOR = '#eaf0f6';
export var FORM_STATIC_LABELS_COLOR = '#7c98b6';
export var FORM_TOGGLE_BACKGROUND_COLOR = '#ffffff';
export var FORM_TOGGLE_HOVER_BACKGROUND_COLOR = '#eaf0f6';
export var FORM_TOGGLE_BORDER_COLOR = '#cbd6e2';
export var FORM_TOGGLE_DISABLED_FOREGROUND_COLOR = '#99acc2';
export var FORM_TOGGLE_HOVER_FOREGROUND_COLOR = '#0091ae';
export var FORM_TOGGLE_ICON_COLOR = '#99acc2';
export var FORM_TOGGLE_SELECTED_BACKGROUND_COLOR = '#ffffff';
export var FORM_TOGGLE_SELECTED_FOREGROUND_COLOR = '#00a4bd';
export var HR_BORDER_COLOR = '#dfe3eb';
export var ICON_DEFAULT_COLOR = '#7c98b6';
export var MODAL_BACKGROUND_COLOR = '#ffffff';
export var MODAL_CLOSE_BUTTON_FOREGROUND_COLOR = '#99acc2';
export var MODAL_DANGER_FOREGROUND_COLOR = '#ffffff';
export var MODAL_FOOTER_BACKGROUND_COLOR = '#ffffff';
export var MODAL_HEADER_BACKGROUND_COLOR = '#00bda5';
export var MODAL_HEADER_FOREGROUND_COLOR = '#ffffff';
export var MODAL_HEADER_START_GRADIENT = '#00a4bd';
export var MODAL_HEADER_MIDDLE_GRADIENT = '#00afb2';
export var MODAL_HEADER_END_GRADIENT = '#00bda5';
export var MODAL_HEADING_INVERTED_FOREGROUND_COLOR = '#ffffff';
export var MODAL_UPGRADES_FOREGROUND_COLOR = '#ffffff';
export var MODAL_UPGRADES_END_GRADIENT = '#ff8f59';
export var MODAL_UPGRADES_START_GRADIENT = '#ff7a59';
export var MODAL_SUCCESS_BACKGROUND_COLOR = '#00bda5';
export var MODAL_SUCCESS_FOREGROUND_COLOR = '#ffffff';
export var PAGINATION_ACTIVE_BACKGROUND_COLOR = '#cbd6e2';
export var PAGINATION_HOVER_BACKGROUND_COLOR = '#eaf0f6';
export var PAGINATION_SELECTED_BACKGROUND_COLOR = '#e5f5f8';
export var PAGINATION_SELECTED_BORDER_COLOR = '#7fd1de';
export var SELECTABLE_BOX_BORDER_COLOR = '#7fd1de';
export var SELECTABLE_BOX_SHADOW_COLOR = 'rgba(0, 163, 189, .3)';
export var SELECTABLE_BOX_SELECTED_BORDER_COLOR = '#00a4bd';
export var SELECTABLE_BOX_SELECTED_BACKGROUND_COLOR = '#e5f5f8';
export var SIDENAV_FOREGROUND_COLOR = '#33475b';
export var SIDENAV_HOVERED_BACKGROUND_COLOR = '#eaf0f6';
export var SIDENAV_SELECTED_BACKGROUND_COLOR = '#eaf0f6';
export var TABLE_SORT_ARROW_COLOR = '#cbd6e2';
export var TABLE_SORT_ARROW_SELECTED_COLOR = '#00a4bd';
export var LOADING_INACTIVE_COLOR = '#cbd6e2';
export var LOADING_DEFAULT_COLOR = '#00a4bd';
export var OVERLAY_BACKGROUND_COLOR = '#2d3e50';
export var OVERLAY_BACKGROUND_COLOR_TRANSLUCENT = 'rgba(45, 62, 80, 0.79)';
export var PANEL_CLOSE_BUTTON_FOREGROUND_COLOR = '#ffffff';
export var PANEL_FOOTER_BACKGROUND_COLOR = '#f5f8fa';
export var PANEL_FOOTER_BORDER_COLOR = '#cbd6e2';
export var PANEL_SHADOW_COLOR = 'rgba(66, 91, 118, 0.21)';
export var TABLE_BACKGROUND_COLOR = '#ffffff';
export var TABLE_BORDER_COLOR = '#dfe3eb';
export var TABLE_HEADER_BACKGROUND_COLOR = '#f5f8fa';
export var TABLE_ROW_HOVER_BACKGROUND_COLOR = '#f5f8fa';
export var TABLE_SORTABLE_HOVER_BACKGROUND_COLOR = '#e5f5f8';
export var TABLE_SORTABLE_HOVER_ICON_COLOR = '#7c98b6';
export var TABLE_SORTABLE_SORTED_BACKGROUND_COLOR = '#eaf0f6';
export var TAG_AVATAR_BORDER_COLOR = '#7fd1de';
export var TEMPLATE_SECTION_DIVIDER_BORDER_COLOR = '#cbd6e2';
export var TOOLTIP_FOREGROUND_COLOR = '#ffffff';
export var TOOLTIP_DANGER_BACKGROUND_COLOR = '#f2545b';
export var TOOLTIP_DEFAULT_BACKGROUND_COLOR = '#425b76';
export var TOOLTIP_LONGFORM_BACKGROUND_COLOR = '#ffffff';
export var TOOLTIP_LONGFORM_CLOSE_BUTTON_COLOR = '#0091ae';
export var TOOLTIP_LONGFORM_FOCUS_COLOR = '#00a4bd';
export var WIZARD_HEADER_BACKGROUND_COLOR = '#ffffff';
export var WIZARD_HEADER_BORDER_COLOR = '#cbd6e2';
export var DEVICE_FRAME_COLOR = '#7c98b6';